import {useDeferredValue} from 'react';
import {HexColorPicker} from 'react-colorful';

type Props = {
  colour: string;
  presetColours?: string[];
  setColour: React.Dispatch<React.SetStateAction<string>>;
};
export function ColourPicker(props: Props): React.JSX.Element {
  const deferred = useDeferredValue(props.colour);

  return (
    <div className="bg-slate1">
      <HexColorPicker
        color={deferred}
        onChange={props.setColour}
        className="w-full!"
      />

      {props.presetColours && (
        <div className="mt-2 flex flex-wrap gap-2">
          {props.presetColours.map((presetColour) => (
            <button
              key={presetColour}
              type="button"
              style={{backgroundColor: presetColour}}
              className="block size-8 cursor-pointer rounded-md border-0 shadow-xs dark:outline-solid dark:outline-1 dark:outline-slate6"
              onClick={() => props.setColour(presetColour)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
